import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `AccountPickerControllerStateProvider` not mounted on RN.
export default function useAccountPickerControllerState(): any {
  const { state } = useController('AccountPickerController' as any)
  return state as any
}
